(()=>{const io=new IntersectionObserver(e=>e.forEach(x=>{if(x.isIntersecting){x.target.classList.add("in");io.unobserve(x.target)}}),{threshold:.12});
document.querySelectorAll(".rv").forEach(n=>io.observe(n));

(()=>{const root=document.querySelector('.pag-tt'),bar=root&&root.querySelector('.pbar');if(!bar)return;
const wrap=document.querySelector('.page-wrapper');
const upd=()=>{const inner=wrap&&wrap.scrollHeight>wrap.clientHeight+1&&getComputedStyle(wrap).overflowY!=='visible';
const view=inner?wrap.clientHeight:innerHeight,r=root.getBoundingClientRect(),top=inner?wrap.getBoundingClientRect().top:0,total=r.height-view;
bar.style.setProperty('--p',total>0?Math.min(1,Math.max(0,(top-r.top)/total)):0)};
addEventListener('scroll',upd,{passive:true});if(wrap)wrap.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd()})();
(()=>{
const root=document.querySelector('.pag-tt');if(!root)return;
const rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine=matchMedia('(hover: hover) and (pointer: fine)').matches;
const wrap=document.querySelector('.page-wrapper');
const scroller=()=>wrap&&wrap.scrollHeight>wrap.clientHeight+1&&getComputedStyle(wrap).overflowY!=='visible'?wrap:window;
const io=(fn,opt)=>{const o=new IntersectionObserver(e=>e.forEach(x=>fn(x,o)),opt);return o};

/* headings: split into words */
if(!rm)root.querySelectorAll('.article h2.rv, .princ h2.rv, .cta h2.rv').forEach(h=>{let i=0;
  const walk=n=>[...n.childNodes].forEach(c=>{
    if(c.nodeType===3){const f=document.createDocumentFragment();
      c.textContent.split(/(\s+)/).forEach(t=>{if(!t)return;if(/^\s+$/.test(t)){f.appendChild(document.createTextNode(t));return}
        const s=document.createElement('span');s.className='w';s.style.setProperty('--i',i++);s.textContent=t;f.appendChild(s)});
      c.replaceWith(f)}else if(c.nodeType===1)walk(c)});
  walk(h);h.classList.add('split')});

/* quotes / statements */
const q=io((x,o)=>{if(x.isIntersecting){x.target.classList.add('in2');o.unobserve(x.target)}},{threshold:.4});
root.querySelectorAll('.pull,.statement').forEach(n=>q.observe(n));

/* feature numbers roll up */
if(!rm){const r=io((x,o)=>{if(!x.isIntersecting)return;o.unobserve(x.target);const el=x.target,end=parseInt(el.textContent,10),t0=performance.now();
  const step=t=>{const p=Math.min(1,(t-t0)/800),e=1-Math.pow(1-p,3);el.textContent=String(Math.round(end*e)).padStart(2,'0');if(p<1)requestAnimationFrame(step)};
  el.textContent='00';requestAnimationFrame(step)},{threshold:.6});
  root.querySelectorAll('.feat .num').forEach(n=>r.observe(n))}

/* chapter rail + scroll-spy */
const links=[...root.querySelectorAll('nav.index a[href^="#s"]')];
if(links.length){
  const rail=document.createElement('nav');rail.className='rail';rail.setAttribute('aria-label','Chapters');
  rail.innerHTML=links.map(a=>`<a href="${a.getAttribute('href')}"><span class="l">${a.textContent.replace(/^\d+/,'').trim()}</span><i></i></a>`).join('');
  root.appendChild(rail);
  const rl=[...rail.children],ids=links.map(a=>a.getAttribute('href').slice(1));
  const setOn=id=>{ids.forEach((d,i)=>{const on=d===id;links[i].classList.toggle('on',on);rl[i].classList.toggle('on',on)})};
  const spy=io(x=>{if(x.isIntersecting)setOn(x.target.id)},{rootMargin:'-40% 0px -55% 0px'});
  ids.forEach(d=>{const s=document.getElementById(d);if(s)spy.observe(s)});
  const hero=root.querySelector('.hero'),end=root.querySelector('.next');
  let heroOut=false,endIn=false;const sync=()=>rail.classList.toggle('on',heroOut&&!endIn);
  io(x=>{heroOut=!x.isIntersecting;sync()},{threshold:.2}).observe(hero);
  if(end)io(x=>{endIn=x.isIntersecting;sync()},{threshold:.1}).observe(end);
}

/* back to top */
root.querySelectorAll('.foot span').forEach(s=>{if(/back to top/i.test(s.textContent)){
  const b=document.createElement('button');b.type='button';b.className='totop';b.textContent=s.textContent;
  b.addEventListener('click',()=>{const sc=scroller();sc===window?window.scrollTo({top:0,behavior:'smooth'}):sc.scrollTo({top:0,behavior:'smooth'})});s.replaceWith(b)}});

/* pointer effects */
if(fine&&!rm){
  root.querySelectorAll('.bezel,.box').forEach(c=>{const s=document.createElement('span');s.className='spot';s.setAttribute('aria-hidden','true');c.appendChild(s)});
  const hero=root.querySelector('.hero'),p1=root.querySelector('.stage .p1'),p2=root.querySelector('.stage .p2'),chips=[...root.querySelectorAll('.chipf')],gl=root.querySelector('.hero .glow.a');
  let frame=0,last=null;
  const run=()=>{frame=0;const e=last;if(!e)return;
    const t=e.target.closest('.pc,.feat'),c=e.target.closest('.bezel,.box');
    if(c){const r=c.getBoundingClientRect();c.style.setProperty('--mx',(e.clientX-r.left)+'px');c.style.setProperty('--my',(e.clientY-r.top)+'px')}
    if(t){const r=t.getBoundingClientRect(),nx=(e.clientX-r.left)/r.width-.5,ny=(e.clientY-r.top)/r.height-.5;
      t.style.rotate=`${-ny} ${nx} 0 ${Math.min(1,Math.hypot(nx,ny)*2)*4}deg`}
    const h=e.target.closest('.hero');
    if(h&&p1){const r=hero.getBoundingClientRect(),nx=(e.clientX-r.left)/r.width-.5,ny=(e.clientY-r.top)/r.height-.5;
      p1.style.translate=`${nx*-22}px ${ny*-14}px`;p2.style.translate=`${nx*30}px ${ny*18}px`;chips.forEach((c,i)=>c.style.translate=`${nx*(i?-12:14)}px ${ny*(i?-8:10)}px`);if(gl)gl.style.translate=`${nx*40}px ${ny*30}px`}};
  root.addEventListener('pointermove',e=>{last=e;if(!frame)frame=requestAnimationFrame(run)},{passive:true});
  root.addEventListener('pointerout',e=>{const t=e.target.closest&&e.target.closest('.pc,.feat');if(t&&!t.contains(e.relatedTarget))t.style.rotate=''});
  hero.addEventListener('pointerleave',()=>{[p1,p2,gl,...chips].forEach(n=>n&&(n.style.translate=''))});
  /* magnetic buttons */
  root.querySelectorAll('.btn').forEach(b=>{
    b.addEventListener('pointermove',e=>{const r=b.getBoundingClientRect();b.style.translate=`${((e.clientX-r.left)/r.width-.5)*10}px ${((e.clientY-r.top)/r.height-.5)*8}px`});
    b.addEventListener('pointerleave',()=>{b.style.translate=''})});
}
})();})();
